import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "mail",
  "use": "mail-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"mail\"><path fill=\"currentColor\" d=\"M20.53 2.13H3.47A3.48 3.48 0 0 0 0 5.6v12.8a3.48 3.48 0 0 0 3.47 3.47h17.06A3.48 3.48 0 0 0 24 18.4V5.6a3.48 3.48 0 0 0-3.47-3.47zM3.47 4.81h17.06a.81.81 0 0 1 .57.25L12 11.43 2.91 5.06a.77.77 0 0 1 .56-.25zm17.06 14.38H3.47a.8.8 0 0 1-.79-.79V8.18L12 14.7l9.32-6.52V18.4a.8.8 0 0 1-.79.79z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol